import { Injectable } from "@angular/core";
import { SgKdConstants } from "../sg-kd-constants";

/**
 * 郵便番号フォーマットするサービス
 * @export
 * @class ZipcodeFormatService
 */
@Injectable({
  providedIn: 'root'
})
export class ZipcodeFormatService {

  constructor() { }

  /**
   * 郵便番号フォーマット（ハイフン付与）
   * @param value 
   * @returns ハイフンを付与した郵便番号
   */
  public formatZipcode(value: string): string {

    if (value === null) {
      return SgKdConstants.STR.EMPTY;
    }

    if (value.length == 7) {
      if (value.match(SgKdConstants.PATTERN.HAN_NUM)) {
        return value.slice(0, 3) + SgKdConstants.STR.HYPHEN + value.slice(3, 7);
      }
    }
    return value;
  }

  /**
   * 郵便番号フォーマット（ハイフン除去）
   * @param value 
   * @returns ハイフンを除去した郵便番号
   */
  public reformatZipcode(value: string): string {

    // if (value === null) {
    //   return SgKdConstants.STR.EMPTY;
    // }

    if (value.match(SgKdConstants.PATTERN.POST_NO)) {
      return value.replace(/-/g, '');
    }

    return value;
  }
}
